import { ReviewType } from '@/enums';

export const reviewTypeToInfoMapping = {
  [ReviewType.SYSTEMATIC]: {
    title: 'Systematic Review',
    description:
      'You wish to gather all available evidence relating to a specific topic and have a well-formulated research question',
    timeframe: '12-24 months',
    numReviewers: '2-3 reviewers',
  },
  [ReviewType.SCOPING]: {
    title: 'Scoping Review',
    description:
      'You have a broad topic or multiple research questions, as opposed to a single, well-formulated question',
    timeframe: '12-24 months',
    numReviewers: '2-3 reviewers',
  },
  [ReviewType.RAPID]: {
    title: 'Rapid Review',
    description:
      'You wish to gather all evidence on your topic, but have a limited timeframe in which to complete a review',
    timeframe: '2-4 months',
    numReviewers: '1+ reviewers',
  },
  [ReviewType.UMBRELLA]: {
    title: 'Umbrella Review',
    description:
      'You plan to review other published systematic reviews on your topic',
    timeframe: '12-24 months',
    numReviewers: '2-3 reviewers',
  },
  [ReviewType.NARRATIVE]: {
    title: 'Narrative Review',
    description:
      'Your review will target on a specific subset of the available evidence for your topic, focusing on a specific narrative',
    timeframe: '3-6 months',
    numReviewers: '1+ reviewers',
  },
  [ReviewType.META_ANALYSIS]: {
    title: 'Meta-Analysis',
    description:
      "You're conducting a systematic review and will use statistical methods to evaluate and synthesise/summarise results",
    timeframe: '6-12 months',
    numReviewers: '2-3 reviewers',
  },
};
